<div class="verfy-wrap">
    <div class="verfy-screen-logo">
        <img alt="" src="assets/images/io-logo-green.svg">
    </div>
    <div class="verfy-box">
      <div *ngIf="isServiceUp else systemDown">
        <h2>All Systems Operational</h2>
      </div>
      <ng-template #systemDown>
        <div>
          <h2>Systems Impacted</h2>
        </div>

      </ng-template>


      <div>
        <div class="border-1 border-black-alpha-20 border-round">

            <div class="px-3 py-4 border-bottom-1 border-black-alpha-20">
                <h3> IO Health Web App</h3>
                <!-- <p class="text-left text-sm">Uptime over the past 90 days. View historical uptime.</p> -->

                <div class="flex w-full justify-content-between">
                    <div class="status-indc"></div>
                </div>
            </div>
            <div class="px-3 py-4 border-bottom-1 border-black-alpha-20">
                <h3> IO Health Public API</h3>
                <!-- <p class="text-left text-sm">Uptime over the past 90 days. View historical uptime.</p> -->
                <div *ngIf="isServiceUp; else falseState" class="flex w-full justify-content-between">
                    <div class="status-indc"></div>
                </div>
              <ng-template #falseState>
                <div class="flex w-full justify-content-between">
                  <div class="status-false"></div>
                </div>
              </ng-template>
            </div>
      </div>
    </div>
    <div class="powered-wrapper">
      <span class="text-center">{{ footerText }} {{ currentReleaseVersion }}</span>
      <div class="image-wrapper">

      </div>
  </div>
  </div>
